module.exports = __webpack_public_path__ + "static/vapormario-a0aa43a666e7f3d1cb050786d9de2598.jpg";